import * as React from "react";
import {Link} from "react-router-dom";
import Header from "../components/navigation/Header";
import FalconFooter from "../components/navigation/FalconFooter";
import {productHelper, ProductsEnum, resourcesHelper} from "@falcon/services";

interface IState {
}

declare global {
    interface Window {
        // Google analytics data layer
        LvDataLayer: any;
    }
}

export class HelloPage extends React.Component<{}, IState> {

    public async componentDidMount() {
        document.title = `${resourcesHelper.THEME} login page`;

        window.LvDataLayer = {
            pageTitle: "Flow login page"
        }
    }

    public render(): React.ReactNode {
        return (
            <div id="root">
                <Header/>
                <div className="main-plugin panel mb-3">
                    <div className="text-group title plugin pt-md-0">
                        <h1 className="text-blue-1 font-weight-medium margin-bottom-8">Log in with us</h1>
                    </div>
                    <div className="new-quote-container hello">
                        <a href="/dashboard" className="btn btn-primary btn-next plugin" id="login">Log in</a>
                    </div>
                    <div className="plugin hello w-100">
                        <Link to={this.getSkipRegistrationUrl()} id="skipRegistration" className="mb-md-0">Don’t have a policy with us, get a new quote</Link>
                    </div>
                </div>
                <FalconFooter/>
            </div>
        );
    }

    private getSkipRegistrationUrl(): string {
        const rentersEnabled: boolean = process.env.REACT_APP_RENTERS_ENABLED ? JSON.parse(process.env.REACT_APP_RENTERS_ENABLED) : true;
        return rentersEnabled ? '/products' : productHelper.getNewBusinessUrl(ProductsEnum.MOTOR);
    }

}
